module.exports = __webpack_public_path__ + "static/cartepostale-DEI-lesfillesshabillentcommeellesveulent4-1200-2c4721a3b00b8f146178701be7a5dd6b.png";